module.exports = __webpack_public_path__ + "img/babybook-syringe.72a31c41.svg";